import some from 'lodash/some';

const hasWarning = item => some(item.orderItems, elem => elem.expirationDate !== null);

export default hasWarning;
